export const taskTypes = {
  BATCH_OPEN_TASK_GROUP_BY_SEARCH: {value: 56, label: '按搜索结果异步开启目标数'},
  BATCH_CLOSE_TASK_GROUP_BY_SEARCH: {value: 57, label: '按搜索结果异步关闭目标数'},
  USER_TAG_BY_CELLPHONE_SHA256: {value: 266, label: '批量标签池操作(按手机号sha256)'},
  BATCH_EXPORT_RECORD_REMARK: {value: 267, label: '录音标记批量导出'},
  BATCH_EXPORT_USER_AUDIT_WORKINFO: {value: 268, label: '按搜索条件导出用户职业信息'},
  BATCH_UPDATE_TASK_AFTER_MARKET_MODIFIED: {value: 269, label: '门店修改后更新任务属性'},
  BATCH_EXPORT_ORDER_SNEAK_SIMILARITY: {value: 270, label: '导出工单抓拍照片对比相似度数据'},
  BATCH_EXPORT_USER_COVERAGE_BY_MARKET_ID: {value: 271, label: '按门店ID批量导出零工覆盖指数'},
  BATCH_EXPORT_USER_COVERAGE_BY_GEO: {value: 272, label: '按经纬度批量导出零工覆盖指数'},
  BATCH_ADD_TAG_BY_CONDITION: {value: 273, label: '按搜索条件查找用户并添加标签'},
  BATCH_DEL_TAG_BY_CONDITION: {value: 274, label: '按搜索条件查找用户并删除标签'},
  BATCH_SUGGEST_PRICE_AND_CREATE_TASK: {value: 276, label: '计算门店任务建议定价并创建任务'},
  BATCH_EXPORT_LOW_SCORE_ORDER_FACE: {value: 280, label: '人脸识别分值导出'},
  BATCH_CREATE_TASK_WITH_TEMPLATE: {value: 281, label: '批量添加任务之替换选模版说明'},
  BATCH_REACTIVE_TASK: {value: 282, label: '批量重新上线任务'},
  BATCH_ORDER_EXPORT_NEW: {value: 283, label: '新版批量导出工单'},
  BATCH_EXPIRE_WORKINFO: {value: 284, label: '批量过期用户职业信息'},
  BATCH_SYNC_PERSONNEL_REQUIREMENT: {value: 285, label: '批量同步批次人员要求到任务'},
  BATCH_TASK_ORDER_EXPORT_NEW: {value: 286, label: '新版批量导出任务工单'},
  BATCH_TASK_EXPORT_NEW: {value: 287, label: '新版批量导出任务'},
  BATCH_BANQUET_TASK_IMPORT: {value: 288, label: '批量导入宴席任务'},
  BATCH_TASK_AUDIT_REFERENCE: {value: 289, label: '上传审核参照数据'},
}



// WEBPACK FOOTER //
// ./src/views/task-batch/task-batch-opts.js